import React, { Component } from 'react'
import Guid from 'guid'
import { WithContext as ReactTags } from 'react-tag-input'
import firebase from 'firebase'
import { find } from 'lodash'
import './styles/style.css'


class TagsEditor extends Component {
    constructor(props) {
        super(props)

        this.state = {
            tags: this.getTags(),
            suggestions: []
        }
        this.handleDelete = this.handleDelete.bind(this)
        this.handleAddition = this.handleAddition.bind(this)
        this.handleDrag = this.handleDrag.bind(this)
    }

    componentDidMount() {
        const tagRef = firebase.database().ref('tags')
        tagRef.on('value', this.setSuggestions.bind(this))
    }

    setSuggestions(snapshot) {
        const data = snapshot.val()
        const suggestions = []
        for (let key in data) {
            const tag = data[key]

            suggestions.push(tag.title)

            this.setState({
                suggestions: suggestions
            })
        }
    }

    returnTags() {
        if (this.props.onChange) {

            const tags = {}
            this.state.tags.forEach((item, i) => {
                tags[item.id] = {
                    id: item.id,
                    title: item.text
                }
            })

            this.props.onChange(tags)
        }
    }

    getTags() {
        if (this.props.tags) {
            const tags = []
            for (let key in this.props.tags) {
                const tag = {
                    id: this.props.tags[key].id,
                    text: this.props.tags[key].title
                }
                tags.push(tag)
            }
            return tags
        }

        return []
    }

    handleDelete(i) {
        let tags = this.state.tags
        tags.splice(i, 1)
        this.setState({ tags: tags }, () => {
            this.returnTags()
        })
    }

    handleAddition(tag) {

        let tags = this.state.tags
        const id = Guid.raw()
        const findRes = find(this.state.tags, { 'text': tag })
        if (!findRes) {
            tags.push({
                id: id,
                text: tag
            })
        }

        if (this.state.suggestions.indexOf(tag) === -1) {
            firebase.database().ref('tags/').push({
                id: id,
                title: tag
            })
        }

        this.setState({ tags: tags }, () => {
            this.returnTags()
        })

       

    }

    handleDrag(tag, currPos, newPos) {
        let tags = this.state.tags

        // mutate array 
        tags.splice(currPos, 1)
        tags.splice(newPos, 0, tag)

        // re-render 
        this.setState({ tags: tags }, () => {
            this.returnTags()
        })
    }

    render() {
        const { tags, suggestions } = this.state

        return (
            <div className="TagsEditorWrapper">
                <ReactTags
                    tags={tags}
                    suggestions={suggestions}
                    handleDelete={this.handleDelete}
                    handleAddition={this.handleAddition}
                    handleDrag={this.handleDrag}
                    placeholder={'Добавить тег'}
                />
            </div>
        )
    }
}

export default TagsEditor





// setTimeout(() => {
    
//     for (let key in this.props.tags) {
//         const tag = this.props.tags[key]
//         if (this.state.suggestions.indexOf(tag.title) === -1) {

//             var id = firebase.database().ref('tags/').push().key

//             const ref = `tags/${id}`

//             firebase.database().ref(ref).set(tag)
//         }
//     }

// }, 1000)


// WEBPACK FOOTER //
// ./src/Components/TagsEditor/index.js